<template>
  <div
    class="ll-progress-card"
    @click="$_onClick()"
  >
    <SvgProgressCircle
      v-if="type==='progress-circle'"
      :width="78"
      :stroke-opacity="1"
      :stroke-width="3"
      :stroke-color="_progressColor"
      :progress="parseInt(_completeProgress)"
      class="ll-progress-card__progress-circle"
      :class="color"
    >
      <i
        class="ll-progress-card__icon"
        :class="icon"
      />
    </SvgProgressCircle>
    <div
      v-if="type==='icon-circle'"
      class="ll-progress-card__progress-circle circle"
    >
      <i
        class="ll-progress-card__icon"
        :class="icon"
      />
    </div>
    <div class="ll-progress-card__content">
      <p
        class="ll-progress-card__content__number"
        :class="color"
      >
        {{ number }}<span
          v-if="hasPercent"
          class="ll-progress-card__content__percent"
        >%</span>
      </p>
      <p class="ll-progress-card__content__title">
        {{ title }}
      </p>
    </div>
  </div>
</template>
<script>
import SvgProgressCircle from "@wasateam/vue-svg-progress-circle";
export default {
  name: "LlProgressCard",
  components: {
    SvgProgressCircle,
  },
  props: {
    type: {
      type: String,
      default: "",
    },
    icon: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    hasPercent: {
      type: Boolean,
      default: false,
    },
    isRed: {
      type: Boolean,
      default: false,
    },
    isYellow: {
      type: Boolean,
      default: false,
    },
    isGreen: {
      type: Boolean,
      default: false,
    },
    number: {
      type: Number,
      default: 0,
    },
    color: {
      type: String,
      default: "",
    },
  },
  computed: {
    _progressColor() {
      return this.color === "red"
        ? "#dd4e41"
        : this.color === "yellow"
        ? "#ffd500"
        : this.color === "green"
        ? "#e5f4ef"
        : "#0585d3";
    },
    _completeProgress() {
      return `${(this.number / 100).toFixed(2) * 100}`;
    },
  },
  methods: {
    $_onClick() {
      this.$emit("click");
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/ll-progress-card";
</style>